import React, { FC } from 'react';
import { Box, IconButton, Typography } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import EmissionsWithLabelStyles from './EmissionsWithLabelStyles';
import { IEmissions } from '../../../../../../../common/model/IEmissions';

const EmissionsWithLabel: FC<IEmissions> = ({ emissions, label }) => {
  const styles = EmissionsWithLabelStyles();

  return (
    <Box
      alignItems={'center'}
      display="flex"
      flexDirection="column"
      justifyContent={'center'}
      data-test="sticky_footer:emissions"
    >
      <Box display="flex" alignItems="center">
        <Typography className={styles.emission} variant={'sectionTitle'} component="span" data-test="emissions:value">
          {emissions}
        </Typography>
        <IconButton className={styles.infoIcon} data-test="emissions:icon">
          <InfoOutlinedIcon fontSize="inherit" />
        </IconButton>
      </Box>
      <Typography className={styles.emissionLabel} variant={'helpingText'} data-test={'emissions:label'}>
        {label}
      </Typography>
    </Box>
  );
};

export default EmissionsWithLabel;
